import { Trans } from '@lingui/react';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { Sheet } from '@startuptools/ui/Sheet';
import { Alert } from '@startuptools/ui/Alert';
import { Table } from '@startuptools/ui/Table';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { useCompanyQuery } from '../../../graphql/react-operations';
import { isNil } from 'lodash-es';
import { ShareCapitalRow } from './ShareCapitalTableRow';

export const ShareCapitalTable = () => {
  const companyId = useCompanyId();
  const {
    data: { company } = {},
    error,
    loading,
  } = useCompanyQuery({ variables: { id: companyId }, fetchPolicy: 'no-cache' });

  if (loading) {
    return null;
  }

  return (
    <Stack gap={2}>
      <Typography level="h2">
        <Trans id="Share Capital" />
      </Typography>

      <Sheet>
        {error ? (
          <Alert variant="outlined" color="danger">
            <Trans id="An error occurred. Please refresh the page. If the error persists, contact our customer support" />
          </Alert>
        ) : (
          company && (
            <Sheet variant="outlined">
              <Table>
                <thead>
                  <tr>
                    <th />
                    <th align="right">
                      <Trans id="Shares" />
                    </th>
                    <th align="right">
                      <Trans id="Share Capital" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ShareCapitalRow
                    header={<Trans id="Current" />}
                    shares={company.sharesTotal}
                    capital={company.shareCapital}
                    currency={company.currency}
                  />
                  {!isNil(company?.sharesMax) && !isNil(company?.shareCapitalMax) && (
                    <ShareCapitalRow
                      header={<Trans id="Maximum" />}
                      shares={company.sharesMax}
                      capital={company.shareCapitalMax}
                      currency={company.currency}
                    />
                  )}
                  {!isNil(company?.sharesMin) && !isNil(company?.shareCapitalMin) && (
                    <ShareCapitalRow
                      header={<Trans id="Minimum" />}
                      shares={company.sharesMin}
                      capital={company.shareCapitalMin}
                      currency={company.currency}
                    />
                  )}
                </tbody>
              </Table>
            </Sheet>
          )
        )}
      </Sheet>
    </Stack>
  );
};
